import { render, staticRenderFns } from "./SwatchSelect.vue?vue&type=template&id=6446c620&"
import script from "./SwatchSelect.vue?vue&type=script&lang=js&"
export * from "./SwatchSelect.vue?vue&type=script&lang=js&"
import style0 from "./SwatchSelect.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseSwatch: require('/opt/build/repo/storefront/components/atoms/Swatch/BaseSwatch.vue').default})
